module.exports = __webpack_public_path__ + "static/media/logo.cb9ccbc6.svg";